type ResultError = { TryError: unknown };
export type Result<T> = T | ResultError;

export function Try<T>(f: () => T): Result<T> {
	try {
		let v = f();
		return v;
	} catch (error) {
		return { TryError: error };
	}
}

export function IsError<T>(r: Result<T>): r is ResultError {
	if (r === null || (typeof r === "object" && "TryError" in r)) {
		return true;
	}

	return false;
}

export function CollectErrors<T>(...r: Result<T>[]): string {
	return r.filter(IsError).reduce((prev, curr) => prev + ", " + curr, "");
}

export function TryParseInt(
	string: string,
	radix?: number | undefined
): Result<number> {
	return Try(() => parseInt(string, radix));
}

export function TryParseFloat(
	string: string,
): Result<number> {
	return Try(() => parseFloat(string));
}